import{createContext as t}from"react";import{DEFAULT_THEME_VERSION as o}from"./constants.js";const r=t(o);export{r as default};
//# sourceMappingURL=ThemeVersionContext.js.map
